import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  ResolveFn,
  RouterStateSnapshot,
} from '@angular/router';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import {
  SitemapCategoryCms,
  SitemapCms,
} from '~/cms/interfaces/sitemap.cms.interface';
import { CmsService } from '~/cms/services/cms/cms.service';
import { TabBarLinkInterface } from '~/component/router-tab-bar/interfaces/tab-link.interface';
interface SitemapResolverInterface {
  categories: TabBarLinkInterface[];
  sitemapCategory: SitemapCategoryCms;
  title: string;
}
let tabCategories: TabBarLinkInterface[];

export const SitemapResolver: ResolveFn<SitemapResolverInterface> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  cmsService: CmsService = inject(CmsService),
  localizeRouterService: LocalizeRouterService = inject(LocalizeRouterService)
  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
): Observable<any> =>
  cmsService.getSitemap(route.paramMap.get('id')).pipe(
    tap((sitemap: SitemapCms) => {
      tabCategories = sitemap.sitemap_category.map((c) => {
        const path = `${localizeRouterService
          .translateRoute('/attendee.sitemap')
          .toString()}/${c?.slug}`;
        return {
          name: c?.category_name,
          path,
        };
      });
    }),
    map((sitemap: SitemapCms) => {
      return {
        title: sitemap.title,
        categories: tabCategories,
        sitemapCategory: sitemap.sitemap_category.find(
          (c) => c?.slug === route.paramMap.get('id')
        ),
      };
    })
  );
